import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Transactions
export const createTransaction = async (data) => {
  const response = await axios.post(`${API}/transactions`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getTransactions = async () => {
  const response = await axios.get(`${API}/transactions`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteTransaction = async (id) => {
  const response = await axios.delete(`${API}/transactions/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const createCreditCardPayment = async (data) => {
  const response = await axios.post(`${API}/accounts/credit-card-payment`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const createCurrencyExchange = async (data) => {
  const response = await axios.post(`${API}/transactions/currency-exchange`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateTransaction = async (id, data) => {
  const response = await axios.put(`${API}/transactions/${id}`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getTransactionStats = async () => {
  const response = await axios.get(`${API}/transactions/stats`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Admin
export const getAdminStats = async () => {
  const response = await axios.get(`${API}/admin/stats`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAdminUsers = async () => {
  const response = await axios.get(`${API}/admin/users`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAdminUserDetails = async (userId) => {
  const response = await axios.get(`${API}/admin/users/${userId}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateAdminUser = async (userId, data) => {
  const response = await axios.patch(`${API}/admin/users/${userId}`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteAdminUser = async (userId) => {
  const response = await axios.delete(`${API}/admin/users/${userId}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const resetAdminUserFinancialData = async (userId, data) => {
  const response = await axios.post(`${API}/admin/users/${userId}/reset-financial-data`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getSelfFinancialResetSettings = async () => {
  const response = await axios.get(`${API}/auth/me/reset-financial-data/settings`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const resetSelfFinancialData = async (data) => {
  const response = await axios.post(`${API}/auth/me/reset-financial-data`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAccessLogs = async (limit = 50) => {
  const response = await axios.get(`${API}/admin/access-logs?limit=${limit}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteAccessLog = async (logId) => {
  const response = await axios.delete(`${API}/admin/access-logs/${logId}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const clearAccessLogs = async () => {
  const response = await axios.delete(`${API}/admin/access-logs`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAdminSystemStatus = async () => {
  const response = await axios.get(`${API}/admin/system-status`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAdminAuditLogs = async (limit = 100) => {
  const response = await axios.get(`${API}/admin/audit-logs?limit=${limit}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAdminLoginFailures = async (limit = 100) => {
  const response = await axios.get(`${API}/admin/security/login-failures?limit=${limit}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const blockAdminIp = async (data) => {
  const response = await axios.post(`${API}/admin/security/blocked-ips`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const unblockAdminIp = async (ipAddress) => {
  const response = await axios.delete(`${API}/admin/security/blocked-ips/${encodeURIComponent(ipAddress)}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteAdminLoginFailure = async (logId) => {
  const response = await axios.delete(`${API}/admin/security/login-failures/${logId}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const clearAdminLoginFailures = async () => {
  const response = await axios.delete(`${API}/admin/security/login-failures`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAdminImports = async (limit = 100) => {
  const response = await axios.get(`${API}/admin/imports?limit=${limit}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAdminBackups = async () => {
  const response = await axios.get(`${API}/admin/snapshots`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const createAdminBackup = async () => {
  const response = await axios.post(`${API}/admin/snapshots`, {}, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateAdminMaintenance = async (data) => {
  const response = await axios.put(`${API}/admin/maintenance`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAdminExchangeRates = async () => {
  const response = await axios.get(`${API}/admin/exchange-rates`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const refreshAdminExchangeRates = async () => {
  const response = await axios.post(`${API}/admin/exchange-rates/refresh`, {}, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAdminOpenAIBilling = async () => {
  const response = await axios.get(`${API}/admin/openai-billing`, {
    headers: getAuthHeader()
  });
  return response.data;
};
